import React, { Fragment, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { SwipeableDrawer } from '@mui/material';
import { Menu, ContactSupport, Dashboard } from '@mui/icons-material';

import SweetModal from 'components/SweetModal/SweetModal';
import Button from 'components/CustomButtons/Button';

import {
  StyledAppBar,
  StyledToolbar,
  LogoWrapper,
  Logo,
  StyledList,
  StyledListMobile,
  StyledListItem,
  StyledListItemIcon,
  StyledListItemText,
  NavLinkStyled,
  DrawerPaper,
  BurgerMenu,
  NeedHelp,
} from './style/pagesHeaderStyle';

import { routes } from '../../routes/menu/auth';

const PagesHeader = ({ color }) => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [isOpenNeedHelpModal, setIsOpenNeedHelpModal] = useState(false);

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => location.pathname.indexOf(routeName) > -1;

  const toggleNeedHelpModal = () => setIsOpenNeedHelpModal(!isOpenNeedHelpModal);

  const handleDrawerToggle = () => window.innerWidth < 960 && setOpen(!open);

  const modal = (
    <SweetModal
      key='needHelpModal'
      title="Vous avez besoin d'aide ?"
      noCancel
      noSubmit
      noClose
      isOpen={isOpenNeedHelpModal}
      inputs={[
        <p key='needHelpContent'>
          Un problème pour vous connecter, contactez-nous à&nbsp;
          <a href='mailto:contact@viensvoirmontaf.fr'>contact@viensvoirmontaf.fr</a>
        </p>,
      ]}
      toggleModal={toggleNeedHelpModal}
      customFooter={
        <Button onClick={toggleNeedHelpModal} color='primary'>
          Fermer
        </Button>
      }
    />
  );

  const list = (ListComponent) => (
    <ListComponent>
      <StyledListItem>
        <NavLinkStyled href='https://www.viensvoirmontaf.fr'>
          <StyledListItemIcon><Dashboard /></StyledListItemIcon>
          <StyledListItemText primary='Accueil' disableTypography />
        </NavLinkStyled>
      </StyledListItem>
      {routes.map((prop, key) => {
        if (prop.pathTo) return null;
        return (
          <StyledListItem key={key}>
            <NavLinkStyled
              as={NavLink}
              to={prop.path}
              active={activeRoute(prop.path) ? 1 : 0}
              onClick={handleDrawerToggle}
            >
              <StyledListItemIcon><prop.icon /></StyledListItemIcon>
              <StyledListItemText primary={prop.short} disableTypography />
            </NavLinkStyled>
          </StyledListItem>
        );
      })}
    </ListComponent>
  );

  return (
    <Fragment>
      {modal}
      <StyledAppBar elevation={0} ownerState={{ color }}>
        <StyledToolbar disableGutters>
          <LogoWrapper>
            <BurgerMenu onClick={handleDrawerToggle}>
              <Menu />
              <span>MENU</span>
            </BurgerMenu>
            <Logo src='/logo-main-header.svg' alt='logo' />
            {list(StyledList)}
          </LogoWrapper>

          <NeedHelp
            onClick={toggleNeedHelpModal}
            onKeyPress={toggleNeedHelpModal}
            role='button'
            tabIndex={0}
          >
            <span className='text'>Vous avez besoin d&apos;aide ?</span>
            <span className='icon'><ContactSupport /></span>
          </NeedHelp>

          <SwipeableDrawer
            variant='temporary'
            anchor='left'
            open={open}
            classes={{ paper: DrawerPaper }}
            onClose={handleDrawerToggle}
            onOpen={() => { }}
            ModalProps={{ keepMounted: true }}
          >
            {list(StyledListMobile)}
          </SwipeableDrawer>
        </StyledToolbar>
      </StyledAppBar>
    </Fragment>
  );
};

PagesHeader.propTypes = {
  color: PropTypes.oneOf(['whiteColor', 'blackColor', 'primary', 'info', 'success', 'warning', 'danger']),
};

export default PagesHeader;